export default "__VITE_ASSET__BeE6Xr7W__"